export const communityGuidelinesMetaData = {
  metaTitle: 'Community Guidelines for mylo community | Mylo Family',
  metaDescription:
    'Discover our community guidelines for a safe and engaging experience. Learn more about our policies and guidelines here.',
};

// consultancy-agreement.js
export const consultancyAgreementMetaData = {
  metaTitle: 'Consultancy Agreement | Mylo Family',
  metaDescription:
    'Explore our consultancy agreement details. Understand the terms, conditions, and agreements for our consultancy services.',
};

// contact-us.js
export const contactUsMetaData = {
  metaTitle: 'Contact Us if you have any queries | Mylo Family',
  metaDescription:
    'Get in touch with us today. Reach out for inquiries, support, or collaboration opportunities. We are here to assist you!',
};

// form-id.js
export const formIdMetaData = {
  metaTitle: 'Consultation form details | Mylo Family',
  metaDescription:
    'View all the details for the form. Gain insights into the form and its related information. Fill out the form conveniently.',
};

// offline.js
export const offlineMetaData = {
  metaTitle: 'Offline | Mylo Family',
  metaDescription:
    'Oops! It seems you’re offline. Please check your internet connection and try reloading the page.',
};

// url-finder.js
export const urlFinderMetaData = {
  metaTitle: 'URL Finder for locating URLs | Mylo Family',
  metaDescription:
    'Utilize our URL finder tool to locate specific URLs or resources on our website. Search and discover pages easily.',
};

// login.js
export const loginMetaData = {
  metaTitle: 'Login to view your orders | Mylo Family',
  metaDescription:
    'Log in to access your account. Enter your credentials to securely sign in and enjoy personalized experiences.',
};

// remove-user.js
export const removeUserMetaData = {
  metaTitle: 'Remove User | Mylo Family',
  metaDescription:
    'Remove a user from your account. Follow the necessary steps to manage your users effectively and securely.',
};

// reviews-id.js
export const reviewsIdMetaData = {
  metaTitle: 'View in-depth Reviews for any product you like | Mylo Family',
  metaDescription:
    'Read reviews and feedback. Discover what others are saying about our services or products.',
};

// search.js
export const searchMetaData = {
  metaTitle: 'Search your favorite products | Mylo Family',
  metaDescription:
    'Search our website for specific content, articles, products, or information. Find what you’re looking for!',
};

// success.js
export const successMetaData = {
  metaTitle: 'Success | Mylo Family',
  metaDescription:
    'Success! Your action has been completed. Explore more or return to the previous page.',
};

// taglist.js
export const tagListMetaData = {
  metaTitle: 'Tag List | Mylo Family',
  metaDescription:
    'Explore our tag list for categorizing content. Discover articles, posts, or products based on tags.',
};

// user-agreement.js
export const userAgreementMetaData = {
  metaTitle: 'User Agreement for mylo | Mylo Family',
  metaDescription:
    'Read and understand our user agreement. Learn about terms, conditions, and user policies.',
};

// user-agreement-success.js
export const userAgreementSuccessMetaData = {
  metaTitle: 'User Agreement Success | Mylo Family',
  metaDescription:
    'Congratulations! You’ve successfully agreed to our user policies. Continue exploring our site!',
};

// video-videoId.js
export const videoIdMetaData = {
  metaTitle: 'Video | Mylo Family',
  metaDescription:
    'Watch an engaging video. Enjoy our content and discover more related videos.',
};

// 404.js
export const notFoundMetaData = {
  metaTitle: '404 Page Not found | Mylo Family',
  metaDescription:
    'Oops! The page you’re looking for doesn’t exist. Explore other pages on our site.',
};

// 410.js
export const goneMetaData = {
  metaTitle: '410 Page Does not exist | Mylo Family',
  metaDescription:
    'Oops! The requested page is no longer available. Discover other content on our website.',
};

// 500.js
export const serverErrorMetaData = {
  metaTitle: '500 Internal Server Error | Mylo Family',
  metaDescription:
    'Oops! Something went wrong on our server. We’re working to fix it. Please try again later.',
};

// redirecting.js
export const redirectingMetaData = {
  metaTitle: 'Redirecting to a new page | Mylo Family',
  metaDescription:
    'We are redirecting you to the requested page. Enjoy exploring!',
};

export const addressPageMetaData = {
  metaTitle: 'Address Page to add or edit address | Mylo Family',
  metaDescription:
    'View and manage your addresses. Add, edit, or delete addresses for a seamless shopping experience.',
};

// payment.js
export const paymentMetaData = {
  metaTitle: 'Payment page to complete your payments  | Mylo Family',
  metaDescription:
    'Securely make payments for your orders. Choose from various payment methods for a hassle-free checkout.',
};

// change-address-page.js
export const changeAddressPageMetaData = {
  metaTitle:
    'Change your address from a list of saved addresses  | Mylo Family',
  metaDescription:
    'Update your address details. Make changes to your existing address information easily.',
};

// partner-with-us.js
export const partnerWithUsMetaData = {
  metaTitle: 'Partner With Us in our ventures | Mylo Family',
  metaDescription:
    'Explore partnership opportunities with us. Join our network and grow your business.',
};

// privacy-policy.js
export const privacyPolicyMetaData = {
  metaTitle: 'Privacy Policy   | Mylo Family',
  metaDescription:
    'Read our privacy policy. Learn how we handle your data and protect your privacy.',
};
